import React, { useState } from 'react';
import { FaUserPlus } from 'react-icons/fa';
import HeyFormEmbed from '../components/HeyFormEmbed';

interface FormWrapperProps {
  formKey: string;
  userType: string;
  userGroup: string;
  submitterEmail?: string;
  submitterId?: string;
  getToken?: () => Promise<string | undefined>;
}

const FormWrapper: React.FC<FormWrapperProps> = ({
  formKey,
  userType,
  userGroup,
  submitterEmail,
  submitterId,
  getToken,
}) => {
  /**
   * Incrementing resetKey unmounts + remounts <HeyFormEmbed>, which
   * re-fetches the form and presents a blank slate — equivalent to the
   * old iframe key trick.
   */
  const [resetKey, setResetKey] = useState(0);

  return (
    // height: calc avoids the min-height trap — h-full on descendants resolves
    // to 0 when the closest ancestor only has min-height (not height).
    // 56px = paddingTop injected by App.tsx to clear the fixed NavBar.
    <div
      className="flex flex-col gap-3 p-3"
      style={{ height: 'calc(100vh - 56px)' }}
    >
      {/* "New patient" action bar */}
      <div className="flex justify-center">
        <div className="w-full max-w-3xl">
          <button
            onClick={() => setResetKey(k => k + 1)}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-white
                       rounded hover:bg-[#0e8fc4] active:bg-[#0b79a8]
                       transition-colors duration-150 text-sm font-medium"
          >
            <FaUserPlus size={18} />
            New {userType}
          </button>
        </div>
      </div>

      {/* Form area — min-h-0 lets the flex child shrink so h-full resolves */}
      <div className="flex justify-center flex-1 min-h-0">
        <div className="w-full max-w-3xl h-full">
          <HeyFormEmbed
            formId={formKey}
            clinicRef={userGroup}
            submitterEmail={submitterEmail}
            submitterId={submitterId}
            getToken={getToken}
            resetKey={resetKey}
          />
        </div>
      </div>
    </div>
  );
};

export default FormWrapper;
